/**
 * API Configuration
 * Configure the SolidRangeAPI backend endpoint
 * 
 * Configuration priority:
 * 1. Runtime config from window.SOLIDRANGE_CONFIG.API_URL (configurable in Azure Portal)
 * 2. Build-time REACT_APP_API_URL environment variable
 * 3. Default localhost for local development
 */

// Extend Window interface for TypeScript
declare global {
  interface Window {
    SOLIDRANGE_CONFIG?: {
      API_URL?: string;
    };
  }
}

const getBaseUrl = (): string => {
  // Priority 1: Runtime config (can be modified in Azure Portal without rebuild)
  if (window.SOLIDRANGE_CONFIG?.API_URL) {
    return window.SOLIDRANGE_CONFIG.API_URL;
  }
  
  // Priority 2: Build-time environment variable
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Priority 3: Default to localhost:8080 for local development (matching mobile app)
  return 'http://localhost:8080';
};

export const API_CONFIG = {
  // Base URL is automatically determined by environment:
  // - Development (.env.development): http://localhost:8080
  // - Production (.env.production): Azure endpoint
  // - Override: Set REACT_APP_API_URL in environment
  baseUrl: getBaseUrl(),
  
  endpoints: {
    auth: '/api/auth',
    detection: '/api/detection/analyze',
    modelInfo: '/api/detection/model-info',
    sync: '/api/sync/sessions',
    images: '/api/images',
    health: '/health',
  },
  
  // Detection confidence threshold (0.0 - 1.0)
  confidenceThreshold: 0.25,
  
  // API request timeout in milliseconds (matching mobile app)
  timeout: 30000, // 30 seconds
};

export const getApiUrl = (endpoint: keyof typeof API_CONFIG.endpoints): string => {
  return `${API_CONFIG.baseUrl}${API_CONFIG.endpoints[endpoint]}`;
};
